import fileServiceModule from "./fileService"

import firebaseService from "./firebaseService"
const firebase = firebaseService()

import authenticationService from "./authenticationService"
const auth = authenticationService

import { toRefs, reactive, watch } from "vue"

const state = reactive({
    mediaUrls: {},
    initializing: false,
    initialized: false


})

const unsubscribeHandles = []



async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle()
    }
    //empty it
    unsubscribeHandles.length = 0
    state.mediaUrls = []

}

async function getMediaUrl(mediaId) {
    let url = null

    if (!mediaId) {
        return null
    }


    if (!state.mediaUrls[mediaId]) {


        try {
            url = await firebase
                .storage()
                .ref(mediaId)
                .getDownloadURL()
            console.log('url', url, mediaId)
        } catch (error) {
            //console.log("error", error);
        }
        if (url) {
            state.mediaUrls[mediaId] = url
        }
    }
    return state.mediaUrls[mediaId] ? state.mediaUrls[mediaId] : null

}
if (!state.initialized && !state.initializing) {

    state.initializing = true


    watch(auth.user, async (user, prevUser) => {
        // console.log('user changed', user);
        teardown()

    })



    state.initialized = true
    state.initializing = false



}


export default {
    ...toRefs(state),
    teardown,
    getMediaUrl
}


